import { useState, useEffect } from 'react';

export const useUnits = () => {
  const [unit, setUnit] = useState(() => {
    const saved = localStorage.getItem('measurementUnit');
    return saved || 'm2';
  });

  const changeUnit = (newUnit) => {
    setUnit(newUnit);
    localStorage.setItem('measurementUnit', newUnit);
  };

  // Conversion factor: 1 m² = 10.764 sqft
  const M2_TO_SQFT = 10.764;
  const SQFT_TO_M2 = 1 / M2_TO_SQFT;

  const convertToM2 = (value) => {
    if (unit === 'sqft') {
      return value * SQFT_TO_M2;
    }
    return value;
  };

  const convertFromM2 = (value) => {
    if (unit === 'sqft') {
      return value * M2_TO_SQFT;
    }
    return value;
  };

  const formatArea = (value) => {
    const formatted = unit === 'sqft' ? Math.round(value) : Math.round(value * 10) / 10;
    return `${formatted.toLocaleString()} ${unit === 'sqft' ? 'sqft' : 'm²'}`;
  };

  const getUnitLabel = () => {
    return unit === 'sqft' ? 'sqft' : 'm²';
  };

  const getPriceLabel = () => {
    return unit === 'sqft' ? '/sqft' : '/m²';
  };

  return {
    unit,
    changeUnit,
    convertToM2,
    convertFromM2,
    formatArea,
    getUnitLabel,
    getPriceLabel,
    M2_TO_SQFT,
    SQFT_TO_M2
  };
};
